jQuery('document').ready(function ($) {
    //MODULE 3 SLIDER
    var mySwiper = new Swiper('.swiper-container_module_3', {
        slidesPerView: 1,
        spaceBetween: 5,
        speed: 900,
        autoplay: {
            delay: 3500,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    // MODULE 9 - CONTACT FORM
    if ($('.module_9_popup')) {
        setTimeout(function () {
            $('.module_9_popup').addClass('show');
            setTimeout(function () {
                $('.module_9_popup').removeClass('show');
            }, 15000);
        }, 500);
    }
});
